import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Navbar from '../components/simons-marketing/Navbar';
import HeroSection from '../components/simons-marketing/HeroSection';
import ValuePropositionSection from '../components/simons-marketing/ValuePropositionSection';
import TestimonialsSection from '../components/simons-marketing/TestimonialsSection';
import ProcessSection from '../components/simons-marketing/ProcessSection';
import GuaranteeSection from '../components/simons-marketing/GuaranteeSection';
import FAQSection from '../components/simons-marketing/FAQSection';
import Footer from '../components/simons-marketing/Footer';

const SimonsMarketing = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('meta.home.title')}</title>
        <meta
          name="description"
          content={t('meta.home.description')}
        />
      </Helmet>
      <div className="min-h-screen bg-white">
        <Navbar />
        <main>
          <HeroSection />
          <ValuePropositionSection />
          <TestimonialsSection />
          <ProcessSection />
          <GuaranteeSection />
          <FAQSection />
          <PricingCTA />
        </main>
        <Footer />
      </div>
    </>
  );
};

const PricingCTA = () => {
  const { t } = useTranslation();

  return (
    <section id="free-analysis" className="py-24 md:py-32 bg-gradient-to-br from-emerald-600 to-teal-700 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
        backgroundSize: '32px 32px',
      }} />
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6">
          {t('simonsMarketing.pricing_cta.title')}
        </h2>
        <p className="text-lg text-emerald-100 mb-10 max-w-2xl mx-auto">
          {t('simonsMarketing.pricing_cta.subtitle')}
        </p>
        <Link
          to="/free-analysis"
          className="inline-flex items-center justify-center px-10 py-4 bg-white text-emerald-700 font-bold rounded-xl hover:bg-emerald-50 transition-colors shadow-lg shadow-emerald-900/30 text-lg"
        >
          {t('simonsMarketing.pricing_cta.button')}
        </Link>
      </div>
    </section>
  );
};

export default SimonsMarketing;
